module.exports = __webpack_public_path__ + "img/android.858cfaa5.png";